import { render, staticRenderFns } from "./CustomInput.vue?vue&type=template&id=395fb8f8&scoped=true"
import script from "./CustomInput.vue?vue&type=script&lang=ts"
export * from "./CustomInput.vue?vue&type=script&lang=ts"
import style0 from "./CustomInput.vue?vue&type=style&index=0&id=395fb8f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395fb8f8",
  null
  
)

export default component.exports